import { Card, CardBody, Col } from "reactstrap";
import { RoundedTouchSpinTitle } from "../../../../../constants";
import { DefaultTouchSpinData, TouchSpinSubTitle } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonTouchSpin from "./common/CommonTouchSpin";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const RoundedTouchSpin = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={RoundedTouchSpinTitle} span={TouchSpinSubTitle} />
        <CardBody className="common-flex rounded-touchspin">
          {DefaultTouchSpinData.map((data, index) => (
            <CommonTouchSpin key={index} arrowIcon={true} color={data} btnClass={`touchspin-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default RoundedTouchSpin;
